module.exports = __webpack_public_path__ + "static/media/YM85_1.35fa4cb9.jpg";